import { useEffect, useState } from "react"

// Returns the current window inner height in pixels, kept in sync via the
// window resize event. window.innerHeight is the layout viewport — the same
// area a `position: fixed; inset: 0` element (like DrawerOverlay) fills — so
// sizing a drawer to this value keeps it visually flush with its overlay on
// iOS Chrome and Android Chrome through URL-bar / bottom-toolbar transitions.
// (visualViewport.height was tried first and underreports the area on iOS
// Chrome when the bottom toolbar is auto-hidden, leaving a gap below the
// drawer.)
export const useVisualViewportHeight = (): number | null => {
  const [height, setHeight] = useState<number | null>(null)

  useEffect(() => {
    if (typeof window === "undefined") return
    const update = () => setHeight(window.innerHeight)
    update()
    window.addEventListener("resize", update)
    window.addEventListener("orientationchange", update)
    return () => {
      window.removeEventListener("resize", update)
      window.removeEventListener("orientationchange", update)
    }
  }, [])

  return height
}
